import { SxProps, Theme, Typography } from "@mui/material";
import { TEXT_SECONDARY } from "@/config/mui/colorPalette";

const AffirmPolicy = ({ sx }: { sx?: SxProps<Theme> }) => {
  return (
    <Typography
      variant="paragraphTiny"
      color={TEXT_SECONDARY}
      sx={{ mb: 2, mt: 0, ...sx }}
    >
      Payment options through Affirm are subject to an eligibility check and are
      provided by these lending partners:{" "}
      <TypographyLink
        href="https://www.affirm.com/lenders"
        ariaLabel="Affirm lenders"
      >
        affirm.com/lenders
      </TypographyLink>
      . Options depend on your purchase amount, and a down payment may be
      required. For licenses and disclosures, see{" "}
      <TypographyLink
        href="https://www.affirm.com/licenses"
        ariaLabel="Affirm licenses"
      >
        affirm.com/licenses
      </TypographyLink>
      .
    </Typography>
  );
};

const TypographyLink = ({
  href,
  ariaLabel,
  children,
}: {
  href: string;
  ariaLabel: string;
  children: React.ReactNode;
}) => (
  <Typography
    href={href}
    component="a"
    target="_blank"
    variant="paragraphTiny"
    rel="noopener noreferrer"
    aria-label={ariaLabel}
    sx={{
      color: TEXT_SECONDARY,
      textDecoration: "underline",
    }}
  >
    {children}
  </Typography>
);

export default AffirmPolicy;
